export default __webpack_public_path__ + "static/media/BarlowSemiCondensed-Light.6f66d7f1.ttf";